import React from 'react';
import { InCellDivisionStyled } from './styles';

export interface InCellDivisionBlockProps {
  withBorder?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  maxWidth?: string;
  children?: React.ReactNode;
  className?: string;
}

const InCellDivisionBlock: React.FC<InCellDivisionBlockProps> = (props) => {
  const { children, withBorder = false, maxWidth, className } = props;
  return (
    <InCellDivisionStyled $maxWidth={maxWidth} $withBorder={withBorder} className={className}>
      {children}
    </InCellDivisionStyled>
  );
};

export default InCellDivisionBlock;
